/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CreateTransactionTypesRequest, TransactionTypesResponse } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class TransactionTypes<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name OptionsTransactionTypes
   * @request OPTIONS:/transactionTypes/{id}
   */
  optionsTransactionTypes = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/transactionTypes/${id}`,
      method: 'OPTIONS',
      ...params,
    });
  /**
   * No description
   *
   * @name GetTransactionTypes
   * @request GET:/transactionTypes
   * @secure
   */
  getTransactionTypes = (params: RequestParams = {}) =>
    this.request<TransactionTypesResponse, any>({
      path: `/transactionTypes`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name CreateTransactionTypes
   * @request POST:/transactionTypes
   * @secure
   */
  createTransactionTypes = (data: CreateTransactionTypesRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/transactionTypes`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsTransactionTypes2
   * @request OPTIONS:/transactionTypes
   * @originalName optionsTransactionTypes
   * @duplicate
   */
  optionsTransactionTypes2 = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/transactionTypes`,
      method: 'OPTIONS',
      ...params,
    });
}
